export default "assets/images/icons/slider-arrow-d94f0637.svg";